module.exports = __webpack_public_path__ + "static/media/MyriadPro-Light.40f971af.svg";